// extracted by mini-css-extract-plugin
module.exports = {"form-b-wizard-action":"style_form-b-wizard-action__D8KQe"};